import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import WeightVolume from './WeightVolume';
import LDrates from './LDrates';
import CargoName from './CargoName';
import CargoType from './CargoType';
import LUports from './LUPorts/LUports';
import PackingList from './PackingList';
import Dangerous from './Dangerous';
import RaisedButton from 'material-ui/RaisedButton';
import { updateCargoOrder } from 'actions/cargoes/orders';
import DetailsForCargo from './HSIdsCodes/DetailsForCargo';
import CargoReferences from './HSIdsCodes/CargoReferences';
import HSCode from './HSIdsCodes/HSCode';
import Transportation from './Transportation';
import { orderNew as mockOrder } from 'mocks/cargo/orderNew';
import Incoterms from './Incoterms';
import Packing from './Packing/Packing';

class CargoBlock extends React.Component {
    constructor(props) {
        super(props);

        this.addCargo = this.addCargo.bind(this);
        this.removeCargo = this.removeCargo.bind(this);
        this.changeCargo = this.changeCargo.bind(this);
    }

    addCargo() {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo.push(mockOrder.cargo[0]);
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    removeCargo(cargoIndex) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo.splice(cargoIndex, 1);
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    /**
     * 
     * @param {[{ field: string, value: any, type: 'number' | 'array' }]} changes 
     */
    changeCargo(changes) {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        let newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        changes.forEach(({ field, value, type }) => {
            if (type === 'number' && value === '') {
                value = undefined;
            }
    
            if (type === 'array') {
                newCargoOrder = _.set(newCargoOrder, field, [...newCargoOrder[field], value]);
            } else {
                newCargoOrder = _.set(newCargoOrder, field, value);
            }
        });
    
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    render() {
        const { cargo } = this.props.cargoOrder;
        return (
            <div>
                {
                    cargo.map((cargoItem, cargoIndex) => (
                        <div key={cargoIndex}>
                            <br />
                            <hr />
                            <br />
                            <div className='row'>
                                <div className='one-forth' />
                                <div className='one-forth' style={{ display: 'flex', justifyContent: 'center', fontSize: '13px' }} >
                                        Cargo {cargoIndex + 1}: 
                                </div>
                                <div className='one-forth'>
                                    {
                                        cargoIndex === 0 && 
                                            <RaisedButton
                                                labelStyle={{ fontSize: '10px' }}
                                                style={{ height: '25px', margin: '0 5px 0 -10px' }}
                                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                                label='Add'
                                                primary
                                                onClick={() => this.addCargo()}
                                            />
                                    }
                                    {
                                        cargoIndex !== 0 && 
                                            <RaisedButton
                                                labelStyle={{ fontSize: '10px' }}
                                                style={{ height: '25px' }}
                                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                                label='Remove'
                                                secondary
                                                onClick={() => this.removeCargo(cargoIndex)}
                                            />
                                    }
                                </div>
                            </div>
                            <CargoName 
                                numberOrderTable={this.props.numberOrderTable} 
                                cargoPackingIndex={cargoIndex} 
                            />
                            <CargoType 
                                numberOrderTable={this.props.numberOrderTable} 
                                cargoPackingIndex={cargoIndex} 
                            />
                            <CargoReferences 
                                cargoIndex={cargoIndex} 
                                changeCargo={this.changeCargo}
                                numberOrderTable={this.props.numberOrderTable} 
                            />
                            <HSCode 
                                cargoIndex={cargoIndex}
                                changeCargo={this.changeCargo}
                                numberOrderTable={this.props.numberOrderTable} 
                            />
                            <DetailsForCargo
                                cargoIndex={cargoIndex} 
                                changeCargo={this.changeCargo}
                                numberOrderTable={this.props.numberOrderTable} 
                            />
                            <hr />
                            <Transportation
                                cargoIndex={cargoIndex} 
                                changeCargo={this.changeCargo}
                                cargoItem={cargoItem}
                            />
                            <hr />
                            <Incoterms 
                                cargoIndex={cargoIndex} 
                                changeCargo={this.changeCargo}
                                incoterms={this.props.cargoOrder.incoterms}
                            />
                            <hr />
                            <LUports numberOrderTable={this.props.numberOrderTable} />
                            <hr />
                            <LDrates numberOrderTable={this.props.numberOrderTable} />
                            <hr />
                            <WeightVolume 
                                numberOrderTable={this.props.numberOrderTable}
                                cargoPackingIndex={cargoIndex} 
                            />
                            <hr />
                            <Dangerous 
                                numberOrderTable={this.props.numberOrderTable} 
                                cargoPackingIndex={cargoIndex} 
                            />
                            <hr />
                            <PackingList 
                                numberOrderTable={this.props.numberOrderTable}
                                cargoPackingIndex={cargoIndex} 
                            />
                            <hr />
                            <Packing 
                                numberOrderTable={this.props.numberOrderTable}
                                cargoPackingIndex={cargoIndex} 
                            />
                        </div>
                    ))
                }
                <hr />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
    }),
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(CargoBlock);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoBlock.jsx